import { PolicyTspsInput, Tsp, useFindPolicyTsps } from "../../api/policy"
import { useApiForArray } from "./useApiForArray"

export const useFindPolicyAssociations = ({ id }: { id: string }) => {
  const [res, reload] = useFindPolicyTsps({
    id,
  })
  return useApiForArray<Tsp, PolicyTspsInput>(res, reload)
}
